var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 484.59,
    height: 235,
    viewBox: "0 0 484.59 235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2e9bf0;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467.66,27.81c-33.32-19.43-71.19-9.11-97.08,3l-77.19,36L160.65,0,81.59,3.4,191.21,114.53l-69.86,33.18L48.66,120.05,0,142.74l44,54.62c-4.65,5.54-8.86,13.34-5,21.54,5,10.71,19.75,16.1,44,16.1q7.44,0,16.08-.68c26.57-2.1,55.37-8.88,73.39-17.28L448.27,88.38C472.1,77.27,484,65.6,484.56,52.71,484.87,46,482.18,36.27,467.66,27.81ZM439.84,70.3,163.93,199c-15.34,7.15-40.54,13.15-64.18,15.27-24.17,2.17-37.09-.55-41.4-2.86a37.91,37.91,0,0,1,5.6-5.81l7.17-6.31L31.51,150.06l17.94-8.36,72.76,27.69L225.12,120.5,127.37,21.4l28.95-1.25L293.06,88.93,379,48.86C410.4,34.22,436.84,32.94,457.62,45h0c5.23,3.05,7.06,5.71,7,6.76C464.63,51.87,464,59,439.84,70.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanIcon);
export default __webpack_public_path__ + "static/media/plan-icon.6e783081250d7cb9ef2ab1b607a097be.svg";
export { ForwardRef as ReactComponent };